import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActiveCartService, MultiCartService } from "@spartacus/cart/base/core";

import { OccEndpointsService } from "@spartacus/core";
import { KnBrCustomerContextService } from "src/app/store/kn-br-customer-context/kn-br-customer-context.service";
import {
  KN_BR_CUSTOMER_CURRENT,
  KNBR_DELIVERY_INSTRUCTIONS,
  KNBR_DELIVERY_MODES,
  KNBR_PAYMENT_TYPES,
  KNBR_SET_DEFUALT_DELIVERY_MODE,
  KNBR_SET_DELIVERY_MODE,
  KNBR_GET_CART_API,
  UPDATE_PICKUP_INFO,
  POST_DELIVERY_ADDRESS,
  SET_PICKUP_TYPE_AND_DATE,
  SET_SCHEDULE_DELIVERY_DATE,
  ORDER_CONFIRMATION,
  SET_PO_NUMBER,
  KNBR_GET_DEL_TIME_SLOTS,
  CWT_ZIPCODE_VALIDATION,
  GET_PAYMETRIC_IFRAME,
  SAVE_CREDIT_CARD_DETAILS,
  SET_PAYMENT_TYPE,
  SET_BILLING_ADDRESS,
  UPDATE_PLANT_INFO,
  GET_HOLIDAY_LIST,
  REMOVE_PAYMENT_INFO,
  GET_PLANT_ID_LIST,
} from "src/constants/api.endpoints.constant";

import {
  BehaviorSubject,
  catchError,
  filter,
  map,
  Observable,
  take,
  throwError,
} from "rxjs";
import { KnBrQuoteContextService } from "../store/kn-br-quote-context/kn-br-quote-context.service";
import { KnBrQuotesService } from "../store/kn-br-quotes/kn-br-quotes.service";

@Injectable({
  providedIn: "root",
})
export class KnBrCheckoutService {
  customerId: string;
  quoteId: string;
  cartId: string;
  isCheckout$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isOrder$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isPlaceOrderDisabled$ = new BehaviorSubject<boolean>(true);

  private orderSubject = new BehaviorSubject<any>(null);
  order$: Observable<any> = this.orderSubject.asObservable();

  constructor(
    private endPointService: OccEndpointsService,
    private httpClient: HttpClient,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected knBrQuoteService: KnBrQuotesService,
    protected knBrQuoteContextService: KnBrQuoteContextService,
    protected activeCartService: ActiveCartService,
    protected multiCartService: MultiCartService
  ) {
    this.activeCartService.getActiveCartId().subscribe((response) => {
      if (response) {
        this.cartId = response ? response : null;
      }
    });
    this.knBrCustomerContextService
      .getActiveCustomerNumber()
      .subscribe((response) => {
        this.customerId = response ? response : KN_BR_CUSTOMER_CURRENT;
      });
  }

  setDeliveryMode(customerId, queryParams) {
    return this.httpClient.put(
      this.endPointService.buildUrl(
        KNBR_SET_DELIVERY_MODE(customerId, this.cartId),
        { queryParams }
      ),
      {}
    );
  }

  getDeliveryModes(customerId: string, cartId: string) {
    return this.httpClient.get(
      this.endPointService.buildUrl(KNBR_DELIVERY_MODES(customerId, cartId))
    );
  }

  getCartDataResponse(): Observable<any> {
    const url = this.endPointService.buildUrl(
      KNBR_GET_CART_API(this.customerId, this.cartId)
    );
    return this.httpClient.get(url).pipe(
      catchError((err) => {
        console.error("Error fetching CART response:", err);
        return throwError(() => err);
      })
    );
  }

  getCartApiUrl(): Observable<string> {
    return this.activeCartService.getActiveCartId().pipe(
      filter((id) => !!id), // this is  wait until cartId is available (dont remove this)
      take(1),
      map((cartId) =>
        this.endPointService.buildUrl(
          KNBR_GET_CART_API(this.customerId, cartId)
        )
      )
    );
  }

  updatePickupInfo(payload: any): Observable<any> {
    const url = this.endPointService.buildUrl(
      UPDATE_PICKUP_INFO(this.customerId, this.cartId)
    );
    return this.httpClient.put(url, payload);
  }

  setScheduleDeliveryDate(payload: any): Observable<any> {
    const url = this.endPointService.buildUrl(
      SET_SCHEDULE_DELIVERY_DATE(this.customerId, this.cartId),
      {
        queryParams: payload,
      }
    );
    return this.httpClient.put(url, payload);
  }

  updateDeliveryAddress(payload: any): Observable<any> {
    const url = this.endPointService.buildUrl(
      POST_DELIVERY_ADDRESS(this.customerId, this.cartId)
    );
    return this.httpClient.post(url, payload);
  }

  setPickUpTypeAndDate(payload) {
    const pickupTypeUrl = this.endPointService.buildUrl(
      SET_PICKUP_TYPE_AND_DATE(this.customerId, this.cartId),
      {
        queryParams: payload,
      }
    );
    return this.httpClient.put(pickupTypeUrl, {});
  }

  setDefaultDeliveryMode() {
    return this.httpClient.post(
      this.endPointService.buildUrl(
        KNBR_SET_DEFUALT_DELIVERY_MODE(this.customerId, this.cartId)
      ),
      null
    );
  }

  saveDeliveryInstructions(payload) {
    return this.httpClient.put(
      this.endPointService.buildUrl(
        KNBR_DELIVERY_INSTRUCTIONS(this.customerId, this.cartId)
      ),
      payload
    );
  }

  setPoNumberOnCartPage(poNumber) {
    return this.httpClient.put(
      this.endPointService.buildUrl(
        SET_PO_NUMBER(this.customerId, this.cartId),
        {
          queryParams: {
            poNumber,
          },
        }
      ),
      {}
    );
  }

  setPaymentType(cwtPaymentType) {
    return this.httpClient.put(
      this.endPointService.buildUrl(
        SET_PAYMENT_TYPE(this.customerId, this.cartId),
        {
          queryParams: {
            paymentType: cwtPaymentType,
          },
        }
      ),
      {}
    );
  }

  getDeliveryTimeSlotsInInstructions() {
    return this.httpClient.get(
      this.endPointService.buildUrl(
        KNBR_GET_DEL_TIME_SLOTS(this.customerId, this.cartId)
      )
    );
  }

  getPaymentTypes() {
    return this.httpClient.get(
      this.endPointService.buildUrl(
        KNBR_PAYMENT_TYPES(this.customerId, this.cartId)
      )
    );
  }

  getPayMetricIframeUrl() {
    const currentUrl = window.location.href;
    return this.httpClient.get(
      this.endPointService.buildUrl(
        GET_PAYMETRIC_IFRAME(this.customerId, this.cartId),
        {
          queryParams: {
            hostUri: currentUrl,
            store: "cwt",
          },
        }
      )
    );
  }

  saveTheCreditCardDetails(tokenValue, requestBodyPayload) {
    const saveCCUrlValue = this.endPointService.buildUrl(
      SAVE_CREDIT_CARD_DETAILS(this.customerId, this.cartId),
      {
        queryParams: {
          accessToken: tokenValue,
          store: "cwt",
        },
      }
    );
    return this.httpClient.post(saveCCUrlValue, requestBodyPayload);
  }

  setCheckoutFlag(value: boolean) {
    this.isCheckout$.next(value);
  }

  setOrderConfirmationFlag(value: boolean) {
    this.isOrder$.next(value);
  }

  getOrderConfirmationFlag(): Observable<boolean> {
    return this.isOrder$.asObservable();
  }

  setPlaceOrderDisableFlag(value: boolean) {
    this.isPlaceOrderDisabled$.next(value);
  }
  getPlaceOrderDisableFlag(): Observable<boolean> {
    return this.isPlaceOrderDisabled$.asObservable();
  }

  getCheckoutFlag(): Observable<boolean> {
    return this.isCheckout$.asObservable();
  }

  orderConfirmation(payload, poJobNumber) {
    const url = this.endPointService.buildUrl(
      ORDER_CONFIRMATION(this.customerId, this.cartId, payload, poJobNumber)
    );
    return this.httpClient.post(url, {});
  }

  isValidZipCode(zipCode) {
    return this.httpClient.get(
      this.endPointService.buildUrl(
        CWT_ZIPCODE_VALIDATION(this.customerId, this.cartId, zipCode)
      )
    );
  }

  updatePlantIdToCart(queryParams) {
    const plantIdUrl = this.endPointService.buildUrl(
      UPDATE_PLANT_INFO(this.customerId, this.cartId),
      { queryParams }
    );
    return this.httpClient.put(plantIdUrl, {});
  }

  setOrder(order: any): void {
    this.orderSubject.next(order);
  }

  clearOrder(): void {
    this.orderSubject.next(null);
  }

  getOrder(): any {
    return this.orderSubject.value;
  }

  setBillingAddress(customerId, payload) {
    return this.httpClient
      .put(
        this.endPointService.buildUrl(
          SET_BILLING_ADDRESS(customerId, this.cartId),
          {}
        ),
        payload
      )
      .subscribe();
  }

  removePaymentInfo(): Observable<any> {
    const url = this.endPointService.buildUrl(
      REMOVE_PAYMENT_INFO(this.customerId, this.cartId),

    );
    return this.httpClient.delete(url).pipe(
      catchError((error) => {
        console.error('Error removing billing address:', error);
        return throwError(() => error);
      })
    );
  }
  getHolidaysList(){
    const d = new Date();
    let year = d.getFullYear();
    return this.httpClient.get(
      this.endPointService.buildUrl(
        GET_HOLIDAY_LIST(this.customerId, year)
      )
    );
  }


  getPlantIdListData(){
    return this.httpClient.get(
      this.endPointService.buildUrl(
        GET_PLANT_ID_LIST(this.customerId)
      )
    );
  }
}
